import { z } from "zod";

export const investorCodeValidation = z
  .string({
    errorMap: () => ({
      message: "Please enter a valid investor code (ex: XXXXX)",
    }),
  })
  .length(5)
  .transform((s) => s.toUpperCase());
